const runtimeConfig = window.__APP_CONFIG__ || {};
const buildEnv = typeof process !== 'undefined' && process?.env ? process.env : {};

export const API_URL = runtimeConfig.API_URL || buildEnv.REACT_APP_API_URL || '/api';
export const JITSI_DOMAIN = runtimeConfig.JITSI_DOMAIN || buildEnv.REACT_APP_JITSI_DOMAIN || 'localhost:8443';

export function isProbablyJwt(value) {
  if (!value || typeof value !== 'string') {
    return false;
  }

  return value.split('.').length === 3;
}

export function decodeTokenPayload(token) {
  if (!isProbablyJwt(token)) {
    return null;
  }

  try {
    const payload = token.split('.')[1];
    return JSON.parse(atob(payload));
  } catch (err) {
    console.error('Error decoding token:', err);
    return null;
  }
}

export function getTokenSubject(token) {
  return decodeTokenPayload(token)?.sub || null;
}

export function getWebSocketBaseUrl(apiUrl = API_URL) {
  if (apiUrl.startsWith('/api')) {
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    const host = window.location.hostname;
    const port = window.location.port && window.location.port !== '80' && window.location.port !== '443'
      ? `:${window.location.port}`
      : '';
    return `${protocol}//${host}${port}/api/v1`;
  }

  return apiUrl.replace('http://', 'ws://').replace('https://', 'wss://') + '/v1';
}

export function formatCurrency(amount, currency = 'USD') {
  const numericAmount = Number.parseFloat(amount ?? '0');
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number.isNaN(numericAmount) ? 0 : numericAmount);
}